import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

function initLazyLoad() {
    if (typeof window !== 'undefined' && window.lazySizes) {
        window.lazyLoadInstance = window.lazySizes;
        return window.lazySizes;
    }
    return null;
}

export default initLazyLoad;
